export type UrgencyTier = 'safe' | 'warning' | 'critical'

export function daysUntilDeadline(deadlineIso: string, nowIso?: string): number {
  const deadlineDate = deadlineIso.slice(0, 10)
  const todayDate = nowIso ? nowIso.slice(0, 10) : new Date().toISOString().slice(0, 10)
  const deadlineParts = deadlineDate.split('-').map(Number)
  const todayParts = todayDate.split('-').map(Number)
  const deadlineMs = Date.UTC(deadlineParts[0], deadlineParts[1] - 1, deadlineParts[2])
  const todayMs = Date.UTC(todayParts[0], todayParts[1] - 1, todayParts[2])
  return Math.round((deadlineMs - todayMs) / (1000 * 60 * 60 * 24))
}

export function urgencyTier(days: number): UrgencyTier {
  if (days <= 10) return 'critical'
  if (days <= 20) return 'warning'
  return 'safe'
}
